import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";

interface DropdownProps {
  value: any;
  options: any[];
  onChange?: (value: any) => void;
  customDisplayMethod: () => string;
  title?: string;
  width?: number;
}

const DropdownCheckbox: React.FC<DropdownProps> = ({ value, options, onChange, customDisplayMethod, title, width }) => {
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: width || 380,
      },
    },
  };
  return (
    <div style={{ width: `${width || 380}`, color: "white !important"}}>
      <FormControl
        sx={{
          m: 1,
          width: width || 380,
          color: "white",
        }}
        variant="filled"
      >
        <InputLabel sx={{ color: "white", borderColor: "white", ml: 2 }} variant="standard">
          {title || "Filters"}
        </InputLabel>
        <Select
          sx={{ color: "white", borderColor: "white", width: width || 380 }}
          multiple
          value={value}
          onChange={onChange}
          input={<OutlinedInput label="Tag" />}
          renderValue={(selected) => customDisplayMethod()}
          MenuProps={MenuProps}
        >
          {options.map((name) => (
            <MenuItem key={name} value={name} sx={{ width: width || 380 }}>
              <Checkbox checked={value.indexOf(name) > -1} sx={{ color: "white" }} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default DropdownCheckbox;
